import React, { useEffect, useState } from 'react';
import NodeContainer from '../node-container/NodeContainer';
import { Handle, Position, useNodes } from '@xyflow/react';
import MessageModal from './message-modal/MessageModal';
import styles from './MessageNode.module.scss';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';

const MessageNode = ({ id, selected, onNodesDelete, data, ...props }) => {
  const nodes = useNodes();
  const node = nodes.find((node) => node.id === id);

  const [isError, setIsError] = useState(node?.is_Error || false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    if (node?.message) {
      if (!node?.message?.message || node?.message?.message === '<p><br></p>') {
        setIsError(true);
      } else {
        setIsError(false);
      }
    } else {
      setIsError(node?.is_Error || true);
    }
  }, [node?.message]);

  return (
    <>
      <NodeContainer
        name={node.title || 'Message Block'}
        id={id}
        onClick={() => setIsModalOpen(true)}
        backgroundColor={node?.color}
        selected={selected}
        onNodesDelete={onNodesDelete}
        node={node}
        isError={isError}
      >
        <Handle
          className='custom-handle'
          type='target'
          position={Position.Left}
        />
        <div className={styles.svg}>
          <SvgWithBranding type='node-message' color='#787878' />
          {node?.message?.message == undefined ||
          node?.message?.message == '' ||
          node?.message?.message == '<p><br></p>' ? (
            <p className={styles.placeholder}>Enter a message</p>
          ) : (
            <p dangerouslySetInnerHTML={{ __html: node?.message?.message }}></p>
          )}
        </div>

        <Handle
          type='source'
          className='custom-handle'
          position={Position.Right}
        />
      </NodeContainer>

      <MessageModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title='Message'
        id={id}
        isError={isError}
      />
    </>
  );
};

export default MessageNode;
